"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
class EventBus {
    listeners = {};
    globalListeners = [];
    subscribe(eventName, callback) {
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [callback];
        }
        else if (!this.listeners[eventName].includes(callback)) {
            this.listeners[eventName].push(callback);
        }
        return () => this.unsubscribe(eventName, callback);
    }
    unsubscribe(eventName, callback) {
        this.listeners[eventName]?.splice(this.listeners[eventName].indexOf(callback), 1);
    }
    subscribeGlobal(callback) {
        this.globalListeners.push(callback);
        return () => this.unsubscribeGlobal(callback);
    }
    unsubscribeGlobal(callback) {
        this.globalListeners.splice(this.globalListeners.indexOf(callback), 1);
    }
    emit(eventName, args) {
        const eventListeners = this.listeners[eventName] || [];
        eventListeners.forEach((callback) => {
            logInfo(`Вызов события ${String(eventName)}`);
            callback(args);
        });
        this.globalListeners.forEach((globalCallback) => globalCallback(String(eventName), args));
    }
    emitAsync(eventName, args) {
        setTimeout(() => this.emit(eventName, args), 0);
    }
}
exports.EventBus = EventBus;
function logInfo(message) {
    // eslint-disable-next-line no-console
    console.log(`%c ${message} `, 'background: #138d75; color: white;');
}
